import { render, staticRenderFns } from "./MailSegnalazioneWorkflow.vue?vue&type=template&id=10008408&scoped=true"
import script from "./MailSegnalazioneWorkflow.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneWorkflow.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneWorkflow.vue?vue&type=style&index=0&id=10008408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10008408",
  null
  
)

export default component.exports